module.exports = __webpack_public_path__ + "static-v-shop/1770130202702/img/bg-product.30b97be6.jpg";